import { type BaseQueryFn } from '@reduxjs/toolkit/query';
import { createApi } from '@reduxjs/toolkit/query/react';

import { createBaseQuery, type RequestOptions } from '@grafana/api-clients/rtkq';
import { isFetchError } from '@grafana/runtime';
import { getAPIBaseURL } from 'app/api/utils';

export const QUERY_LIBRARY_PAGE_LIMIT = 500;

const API_GROUP = 'queries.grafana.app' as const;
const BASE_URL = getAPIBaseURL(API_GROUP, 'v1');
const BASE_URL_V1BETA1 = getAPIBaseURL(API_GROUP, 'v1beta1');

/**
 * Fall back to v1beta1 when v1 is not served, so the frontend keeps working on
 * instances whose backend has not yet been upgraded to serve the v1 API. The
 * schema is identical across versions, so the same generated endpoints work
 * against either base URL.
 *
 * TODO: Remove this fallback once v1 is widely deployed.
 */
function createBaseQueryWithFallback(): BaseQueryFn<RequestOptions> {
  const v1BaseQuery = createBaseQuery({ baseURL: BASE_URL });
  const v1beta1BaseQuery = createBaseQuery({ baseURL: BASE_URL_V1BETA1 });

  return async (args, api, extraOptions) => {
    const result = await v1BaseQuery(args, api, extraOptions);

    if (result.error && isFetchError(result.error) && result.error.status === 404) {
      return v1beta1BaseQuery(args, api, extraOptions);
    }

    return result;
  };
}

export const api = createApi({
  reducerPath: 'queriesAPIv1',
  baseQuery: createBaseQueryWithFallback(),
  endpoints: () => ({}),
});
